import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { map, take } from 'rxjs';
import { UsertStore } from '../../context/userStore';

export const roleGuard: CanActivateFn = (route) => {
  const oidc = inject(OidcSecurityService);
  const router = inject(Router);
  const userContext = inject(UsertStore);
  const requiredRoles = route.data['roles'] as string[];

  return oidc.userData$.pipe(
    take(1),
    map(user => {
      const userRoles = userContext?.userContext()?.avilableRoles ?? [];
      const hasRole = requiredRoles.some(r =>
        userRoles.includes(r)
      );

      if (hasRole) {
        return true;
      }

      router.navigate(['/error/unauthorized']);
      return false;
    })
  );
};
